import { render, staticRenderFns } from "./AndiamoErogazioneModalComponent.vue?vue&type=template&id=6e546bd4&scoped=true"
import script from "./AndiamoErogazioneModalComponent.vue?vue&type=script&lang=js"
export * from "./AndiamoErogazioneModalComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e546bd4",
  null
  
)

export default component.exports